import dynamic from "next/dynamic";

import { useRef, useState } from "react";
import { Overlay } from "react-bootstrap";

import classNames from "classnames";
import { twMerge } from "tailwind-merge";

import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";

import Checkbox from "components/Checkbox";
import FontAwesomeIcon from "components/FontAwesomeIcon";
import useMediaQuery from "hooks/useMediaQuery";

const Modal = dynamic(() => import("react-modal"), { ssr: false });

const FilterDropdown = ({
  label,
  children,
  dropdown,
  selected,
  className,
  dropdownClassName,
  showOnClick,
  onClick,
  showCheckbox,
  showRadio,
}: {
  label?: string;
  children?: React.ReactNode;
  dropdown?: React.ReactNode;
  selected?: boolean;
  className?: string;
  dropdownClassName?: string;
  showOnClick?: boolean;
  onClick?: () => void;
  showCheckbox?: boolean;
  showRadio?: boolean;
}) => {
  const target = useRef<HTMLButtonElement>(null);
  const [showing, setShowing] = useState(false);

  const { mobile } = useMediaQuery();

  return (
    <>
      <button
        ref={target}
        className={classNames(
          "rounded-full border-none px-[16px] cursor-pointer ",
          showing || selected
            ? "bg-utah-sky text-white"
            : "bg-[#ccc] text-active-black",
          "min-w-0",
          "leading-[25px] md:leading-[31px]",
          "text-sm md:text-base",
          "flex space-x-[5px] items-center",
          className
        )}
        {...(mobile || showOnClick
          ? {
              onClick: () => setShowing(!showing),
            }
          : {
              onMouseEnter: () => setShowing(true),
              onMouseLeave: () => setShowing(false),
              onClick,
            })}
      >
        {showCheckbox && <Checkbox checked={selected} />}
        {showRadio && <Checkbox type="radio" checked={selected} />}
        <span>{label || children}</span>
        <FontAwesomeIcon
          className="text-[11px]"
          icon={showing ? faChevronUp : faChevronDown}
        />
      </button>
      {mobile ? (
        <Modal
          portalClassName="z-[1999]"
          overlayClassName="z-[1999] fixed inset-0 p-[15px] pt-[50px] bg-[rgba(31,31,32,.77)] overflow-y-auto overflow-x-hidden"
          className={twMerge(
            "top-[50px] px-[25px] py-[30px]",
            "outline-none rounded-xl bg-white",
            "flex flex-col",
            dropdownClassName
          )}
          isOpen={showing}
          onRequestClose={() => setShowing(false)}
          onAfterOpen={() => {
            document.body.style.overflowY = "hidden";
          }}
          onAfterClose={() => {
            document.body.style.overflowY = "";
          }}
        >
          <button
            className="absolute top-[0px] right-[15px] border-0 bg-transparent text-[40px] text-[#999] hover:text-active-black"
            onClick={() => setShowing(false)}
          >
            ×
          </button>
          {dropdown}
        </Modal>
      ) : (
        <Overlay
          target={target.current}
          show={showing}
          placement="bottom-start"
        >
          {(props) => (
            <div
              {...props}
              onMouseEnter={() => !showOnClick && setShowing(true)}
              onMouseLeave={() => !showOnClick && setShowing(false)}
              className="absolute z-[1999]"
            >
              <div
                className={twMerge(
                  "mt-[5px] p-[15px]",
                  "bg-white rounded-lg border border-solid border-black/10",
                  dropdownClassName
                )}
              >
                {dropdown}
              </div>
            </div>
          )}
        </Overlay>
      )}
    </>
  );
};

export default FilterDropdown;
